import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

function Fin() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const currentMonthShortForm = () => {
    const monthIndex = new Date().getMonth(); // Get current month index (0-11)
    return months[monthIndex];
  };
  const [selectedMonth, setSelectedMonth] = useState(currentMonthShortForm());
  const fetchData = useCallback(async () => {
    setSelectedMonth(currentMonthShortForm());
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/itemPrice/${selectedMonth}`);

      setData(response.data); // Initialize filteredData with all products
      setLoading(false);
    } catch (err) {
      console.error("❌ Axios error:", err);
      setError(err.response?.data?.message || "Error fetching data");
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (error) return <p>{error}</p>;
  if (!data) return <p>Loading...</p>;

  const {
    productPrice,
    otherProductPrice,
    screenPrice,
    totalPrice,
    sendMoney,
    carryOver,
    available,
    difference,
    status,
  } = data;

  return (
    <div className="flex flex-row space-x-5">
      <div className="p-4 border rounded space-y-2">
        <h2 className="text-lg font-bold mb-2">
          Finance Summary After May 2025
        </h2>
        <h3 className="text-lg font-bold mb-2">
          Current month {selectedMonth}
        </h3>

        <p>
          🧾 <strong>Total Price:</strong> ${totalPrice.toLocaleString()}
        </p>
        <ul className="ml-4 list-disc text-sm">
          <li>Products: ${productPrice.toLocaleString()}</li>
          <li>Other Products: ${otherProductPrice.toLocaleString()}</li>
          <li>Screen: ${screenPrice.toLocaleString()}</li>
        </ul>

        <p>
          💸 <strong>Send Money:</strong> ${sendMoney.toLocaleString()}
        </p>
        <p>
          📦 <strong>Carry Over:</strong> ${carryOver.toLocaleString()}
        </p>
        <p>
          ✅ <strong>Available:</strong> ${available.toLocaleString()}
        </p>
        <p>
          📉 <strong>Difference:</strong> ${difference.toLocaleString()} —{" "}
          <span
            className={status === "debt" ? "text-red-600" : "text-green-600"}
          >
            {status === "debt" ? "Debt" : "Remaining"}
          </span>
        </p>
      </div>
      <div className="p-4 border rounded space-y-2">
        <h2 className="text-lg font-bold mb-2">Finance summary using Birr</h2>
        <h3 className="text-lg font-bold mb-2">
          Current month {selectedMonth}
        </h3>
        <p>
          <strong>profit:</strong>
        </p>
        <p>
          <strong>remaining items:</strong>
        </p>
        <p>
          <strong>unpaid:</strong>
        </p>
        <p>
          <strong>unreceived:</strong>
        </p>
        <p>
          <strong>ethio products:</strong>
        </p>
        <p>
          <strong>bank:</strong>
        </p>
        <ul className="ml-4 list-disc text-sm">
          <li>CBE-1277: <strong>000</strong></li>
          <li>CBE-2357: <strong>000</strong></li>
          <li>BOA-2848: <strong>000</strong></li>
          <li>DASHIN-1011: <strong>000</strong></li>
          <li>AWASH-2701: <strong>000</strong></li>
          <li>TeleBirr-3333: <strong>000</strong></li>
        </ul>
      </div>
      <div className="p-4 border rounded space-y-2">
        <h2 className="text-lg font-bold mb-2">Expenses</h2>
        <p>
          <strong>Office Rent:</strong> $23500
        </p>
        <p>
          <strong>Internet:</strong> $1800
        </p>
        <p>
          <strong>Server rent:</strong> $2300/year
        </p>
        <p>
          <strong>Advertising:</strong>
        </p>
        <ul className="ml-4 list-disc text-sm">
          <li>jiji: $1000</li>
          <li>afrotie: $1200</li>
          <li>telegram: $700</li>
        </ul>
      </div>
    </div>
  );
}

export default Fin;
